(ns app.calendar
  (:require [schema.core :as s]))


(def weekdays [1 ; monday
               2 ; tuesday
               3 ; wednesday
               4 ; thursday
               5 ; friday
               6 ; saturday
               0]) ; sunday


(def Weekday
  (apply s/enum weekdays))

(defn before [d1 d2]
  #?(:clj (.before d1 d2)
     :cljs (< d1 d2)))

(defn after [d1 d2]
  #?(:clj (.after d1 d2)
     :cljs (> d1 d2)))

(defn equals [d1 d2]
  #?(:clj (.equals d1 d2)
     :cljs (= d1 d2)))
